// ACHTUNG: Bei Änderungen dieses ENum bitte auch die Parallelestelle im C'-Code anpassen. Dieser Typ ist sowohl im Frontend als auch im Backend 
// implementiert. Es wird zur Kommunikation per postMessage zwischen Typescript- und C#-Kontexten // verwendet und kann daher nicht per NSWag generiert 
// werden, da es nicht Teil einer HTTP-basierten Schnittstelle ist.
export enum SoftwarepartnerApiInteractionType {
    Unknown = 0,
    Button = 1,
    DragStart = 2,
}